// NEOGRIPX — Shopify Theme JS

// ── Blindaje de enlaces de contacto frente a apps de tracking ──
// Algunas apps de píxeles (ej. Meta/Facebook) interceptan el clic en
// enlaces salientes como WhatsApp para medir campañas, y a veces esa
// redirección propia viene rota y da un error 404 en vez de abrir el
// enlace real. Se corta el evento en fase de captura (antes que
// cualquier otro script de la página pueda reaccionar a él) para que
// estos enlaces naveguen siempre con normalidad.
document.addEventListener('click', (e) => {
  const link = e.target.closest('a[href*="wa.me"], a[href^="tel:"], a[href^="mailto:"]');
  if (link) e.stopImmediatePropagation();
}, true);

// ── Añadir rápido desde las tarjetas de producto ──
document.addEventListener('click', (e) => {
  const btn = e.target.closest('.btn-quick-add');
  if (!btn) return;
  e.preventDefault();
  e.stopPropagation();

  if (btn.dataset.action === 'goto') {
    window.location.href = btn.dataset.url;
    return;
  }

  if (btn.disabled) return;
  const originalText = btn.textContent;
  btn.disabled = true;
  btn.textContent = '...';

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: parseInt(btn.dataset.variant, 10), quantity: 1 })
  })
    .then((r) => { if (!r.ok) throw new Error('add failed'); return fetch('/cart.js'); })
    .then((r) => r.json())
    .then((cart) => {
      btn.classList.add('added');
      btn.textContent = '✓ Añadido';

      let badge = document.querySelector('.nav-cart-count');
      if (!badge) {
        const cartIcon = document.querySelector('.nav-cart');
        if (cartIcon) {
          badge = document.createElement('span');
          badge.className = 'nav-cart-count';
          cartIcon.appendChild(badge);
        }
      }
      if (badge) badge.textContent = cart.item_count;

      setTimeout(() => {
        btn.classList.remove('added');
        btn.textContent = originalText;
        btn.disabled = false;
      }, 1600);
    })
    .catch(() => {
      btn.textContent = 'Error';
      setTimeout(() => {
        btn.textContent = originalText;
        btn.disabled = false;
      }, 1600);
    });
});

document.addEventListener('DOMContentLoaded', () => {

  // ── Navbar scroll ──
  const navbar = document.getElementById('navbar');
  if (navbar) {
    window.addEventListener('scroll', () => {
      navbar.classList.toggle('scrolled', window.scrollY > 50);
    });
  }

  // ── Mobile nav toggle ──
  const hamburger = document.getElementById('hamburger');
  const navLinks = document.getElementById('navLinks');
  if (hamburger && navLinks) {
    hamburger.addEventListener('click', () => {
      const isOpen = navLinks.classList.toggle('open');
      hamburger.classList.toggle('open');
      document.body.style.overflow = isOpen ? 'hidden' : '';
    });
    navLinks.querySelectorAll('a:not(.nav-dropdown-trigger)').forEach(a => {
      a.addEventListener('click', () => {
        navLinks.classList.remove('open');
        hamburger.classList.remove('open');
        document.body.style.overflow = '';
      });
    });
  }

  // ── Hero bg parallax (desktop only) ──
  const heroBg = document.getElementById('heroBg');
  if (heroBg) {
    setTimeout(() => heroBg.classList.add('loaded'), 100);
    if (window.innerWidth > 768) {
      window.addEventListener('scroll', () => {
        heroBg.style.transform = `scale(1.05) translateY(${window.scrollY * 0.15}px)`;
      }, { passive: true });
    }
  }

  // ── Marquesina de fotos (auto-scroll + arrastre + clic) ──
  document.querySelectorAll('[data-marquee]').forEach(wrap => {
    const track = wrap.querySelector('[data-marquee-track]');
    if (!track) return;
    const originalItems = Array.from(track.children);
    if (!originalItems.length) return;

    const speed = parseFloat(wrap.dataset.speed) || 45; // px/segundo
    const pauseOnHover = wrap.dataset.pauseHover === 'true';

    let unit = 0;
    function measureUnit() {
      const first = originalItems[0];
      const last = originalItems[originalItems.length - 1];
      const style = getComputedStyle(track);
      const gap = parseFloat(style.columnGap || style.gap || '0') || 0;
      unit = (last.offsetLeft + last.offsetWidth) - first.offsetLeft + gap;
    }
    function ensureFilled() {
      measureUnit();
      if (unit <= 0) return;
      let guard = 0;
      while (track.scrollWidth < wrap.clientWidth * 2 + unit && guard < 25) {
        originalItems.forEach(item => {
          const clone = item.cloneNode(true);
          clone.setAttribute('aria-hidden', 'true');
          clone.querySelectorAll('a').forEach(a => a.setAttribute('tabindex', '-1'));
          track.appendChild(clone);
        });
        guard++;
      }
    }
    ensureFilled();
    window.addEventListener('resize', ensureFilled);

    function wrapPos(v) {
      if (unit <= 0) return v;
      v = v % unit;
      if (v > 0) v -= unit;
      return v;
    }

    let posX = 0;
    let dragging = false;
    let hovering = false;
    let moved = 0;
    let startX = 0;
    let startPos = 0;
    let lastTime = null;

    function tick(time) {
      if (lastTime === null) lastTime = time;
      const dt = (time - lastTime) / 1000;
      lastTime = time;
      if (!dragging && !(pauseOnHover && hovering)) {
        posX = wrapPos(posX - speed * dt);
      }
      track.style.transform = `translateX(${posX}px)`;
      requestAnimationFrame(tick);
    }
    requestAnimationFrame(tick);

    wrap.addEventListener('mouseenter', () => hovering = true);
    wrap.addEventListener('mouseleave', () => hovering = false);

    // Nota: NO se usa setPointerCapture — retargeta el evento "click" al
    // contenedor y rompe la navegación de los enlaces con el botón
    // izquierdo (el clic derecho seguía funcionando porque no depende de
    // eventos de puntero). En su lugar, se escucha en window mientras dura
    // el arrastre para no perder el movimiento si el cursor sale del track.
    function onPointerMove(e) {
      if (!dragging) return;
      const delta = e.clientX - startX;
      moved = Math.max(moved, Math.abs(delta));
      posX = wrapPos(startPos + delta);
    }
    function onPointerUp() {
      dragging = false;
      window.removeEventListener('pointermove', onPointerMove);
      window.removeEventListener('pointerup', onPointerUp);
      window.removeEventListener('pointercancel', onPointerUp);
    }
    wrap.addEventListener('pointerdown', (e) => {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      dragging = true;
      moved = 0;
      startX = e.clientX;
      startPos = posX;
      window.addEventListener('pointermove', onPointerMove);
      window.addEventListener('pointerup', onPointerUp);
      window.addEventListener('pointercancel', onPointerUp);
    });

    // Evita que un arrastre dispare el enlace de la foto (un clic normal,
    // sin apenas movimiento, navega con normalidad)
    track.querySelectorAll('a').forEach(a => {
      a.addEventListener('click', (e) => {
        if (moved > 6) e.preventDefault();
      });
    });
  });

  // ── Scroll reveal ──
  const revealObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const delay = entry.target.dataset.delay || 0;
        setTimeout(() => entry.target.classList.add('visible'), delay);
        revealObserver.unobserve(entry.target);
      }
    });
  }, { threshold: 0.01, rootMargin: '0px 0px 200px 0px' });

  document.querySelectorAll('.product-card').forEach((el, i) => {
    el.dataset.delay = i * 30;
  });

  document.querySelectorAll('.reveal, .reveal-left, .reveal-right').forEach(el => {
    revealObserver.observe(el);
  });

  // ── Cursor glow ──
  const cursorGlow = document.getElementById('cursorGlow');
  if (cursorGlow) {
    if (window.innerWidth > 768) {
      document.addEventListener('mousemove', (e) => {
        cursorGlow.style.left = e.clientX + 'px';
        cursorGlow.style.top = e.clientY + 'px';
      });
    } else {
      cursorGlow.style.display = 'none';
    }
  }

  // ── Category tab filtering (homepage only — link tabs navigate without JS) ──
  const catTabs = document.querySelectorAll('.cat-tab');
  if (catTabs.length) {
    catTabs.forEach(tab => {
      tab.addEventListener('click', () => {
        if (!tab.dataset.cat) return; // <a> navigation tab — let browser handle
        catTabs.forEach(t => t.classList.remove('active'));
        tab.classList.add('active');
        const cat = tab.dataset.cat;
        document.querySelectorAll('#productsGrid .product-card').forEach(card => {
          const match = cat === 'all' || card.dataset.cat === cat;
          card.classList.toggle('hidden', !match);
        });
      });
    });
  }

  // ── Navbar dropdown (mobile toggle) ──
  document.querySelectorAll('.nav-dropdown-trigger').forEach(trigger => {
    trigger.addEventListener('click', (e) => {
      if (window.innerWidth <= 768) {
        e.preventDefault();
        e.stopPropagation();
        trigger.closest('.nav-dropdown').classList.toggle('open');
      }
    });
  });

  // ── Product gallery thumbnails ──
  const mainImg = document.getElementById('mainProductImg');
  if (mainImg) {
    document.querySelectorAll('.product-thumb').forEach(thumb => {
      thumb.addEventListener('click', () => {
        mainImg.src = thumb.dataset.src;
        document.querySelectorAll('.product-thumb').forEach(t => t.classList.remove('active'));
        thumb.classList.add('active');
      });
    });
  }

  // ── Variant selection (radio pills → hidden select) ──
  const variantSelect = document.querySelector('.variant-id-select');
  if (variantSelect) {
    const productId = document.querySelector('[data-product-id]')?.dataset.productId
      || Object.keys(window.NXVariantData || {})[0];
    const priceEl = document.querySelector('.price-value');
    const compareEl = document.querySelector('.price-compare');
    const addBtn = document.querySelector('.add-to-cart-btn');
    const productThumbs = document.querySelectorAll('.product-thumb');

    // Map: image URL → variant id it belongs to (images not listed here are "shared/extra" and always show)
    const imageOwner = {};
    const variantsForProduct = (window.NXVariantData || {})[productId] || {};
    Object.keys(variantsForProduct).forEach(vId => {
      const img = variantsForProduct[vId].image;
      if (img) imageOwner[img] = vId;
    });

    function filterThumbs(currentVariantId) {
      const currentImg = (variantsForProduct[currentVariantId] || {}).image;
      const items = Array.from(productThumbs);

      items.forEach(thumb => {
        const owner = imageOwner[thumb.dataset.src];
        const belongsToOther = owner && owner !== currentVariantId;
        thumb.classList.toggle('thumb-hidden', !!belongsToOther);
      });

      // Reorder visible thumbs: 1) foto del tipo elegido, 2) diagrama de piezas, 3) resto de extras
      const visible = items.filter(t => !t.classList.contains('thumb-hidden'));
      const cover = visible.find(t => t.dataset.src === currentImg);
      const diagram = visible.find(t => t !== cover && /mesa_de_trabajo/i.test(t.dataset.src));
      const rest = visible.filter(t => t !== cover && t !== diagram);
      const ordered = [cover, diagram, ...rest].filter(Boolean);
      const container = items[0] && items[0].parentElement;
      if (container) ordered.forEach(t => container.appendChild(t));

      items.forEach(t => t.classList.remove('active'));
      if (ordered[0]) ordered[0].classList.add('active');
    }

    function syncVariant() {
      const groups = document.querySelectorAll('.variant-group');
      const selected = Array.from(groups).map(g => {
        const checked = g.querySelector('.variant-radio:checked');
        return checked ? checked.value : '';
      });
      const opts = Array.from(variantSelect.options);
      for (const opt of opts) {
        const vals = [opt.dataset.opt1 || '', opt.dataset.opt2 || '', opt.dataset.opt3 || ''];
        if (selected.every((v, i) => !v || v === vals[i])) {
          variantSelect.value = opt.value;
          break;
        }
      }

      const allData = window.NXVariantData || {};
      const data = (allData[productId] || {})[variantSelect.value];
      if (!data) return;

      if (window.history && window.history.replaceState) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variantSelect.value);
        window.history.replaceState({}, '', url);
      }

      if (mainImg && data.image && mainImg.src !== data.image) {
        mainImg.classList.add('img-swapping');
        setTimeout(() => {
          mainImg.src = data.image;
          mainImg.classList.remove('img-swapping');
        }, 180);
      }
      if (priceEl && data.price) priceEl.textContent = data.price;
      if (compareEl) {
        if (data.compareAtPrice) {
          compareEl.textContent = data.compareAtPrice;
          compareEl.style.display = '';
        } else {
          compareEl.style.display = 'none';
        }
      }
      if (addBtn) {
        addBtn.disabled = !data.available;
        addBtn.textContent = data.available ? 'Añadir al carrito' : 'Sin stock';
      }
      filterThumbs(variantSelect.value);
    }
    document.querySelectorAll('.variant-radio').forEach(r => r.addEventListener('change', syncVariant));
    if (Object.keys(imageOwner).length) filterThumbs(variantSelect.value);
  }

  // ── PDP: carrusel automático de reseñas ──
  document.querySelectorAll('[data-pdp-carousel]').forEach(carousel => {
    const slides = Array.from(carousel.querySelectorAll('.pdp-review-slide'));
    const dotsWrap = carousel.parentElement.querySelector('[data-pdp-dots]');
    const dots = dotsWrap ? Array.from(dotsWrap.querySelectorAll('.pdp-review-dot')) : [];
    if (slides.length < 2) return;
    let current = 0;
    let timer = null;

    function show(index) {
      slides[current].classList.remove('is-active');
      if (dots[current]) dots[current].classList.remove('is-active');
      current = index;
      slides[current].classList.add('is-active');
      if (dots[current]) dots[current].classList.add('is-active');
    }
    function next() { show((current + 1) % slides.length); }
    function start() { timer = setInterval(next, 4500); }
    function stop() { clearInterval(timer); }

    dots.forEach((dot, i) => dot.addEventListener('click', () => { show(i); stop(); start(); }));
    carousel.addEventListener('mouseenter', stop);
    carousel.addEventListener('mouseleave', start);
    start();
  });

  // ── PDP: cierra el hueco entre la ficha de compra y la descripción a ancho completo ──
  function adjustDescGap() {
    const desc = document.querySelector('.product-page-desc-full');
    const layout = document.querySelector('.product-layout');
    const infoPanel = document.querySelector('.product-info-panel');
    if (!desc || !layout || !infoPanel) return;
    if (window.innerWidth < 901) { desc.style.marginTop = ''; return; }
    const layoutBottom = layout.getBoundingClientRect().bottom;
    const infoBottom = infoPanel.getBoundingClientRect().bottom;
    const gap = infoBottom - layoutBottom; // 0 or negative: how much shorter the buy-box column is
    desc.style.marginTop = Math.min(0, gap - 12) + 'px';
  }
  if (document.querySelector('.product-page-desc-full')) {
    window.addEventListener('load', adjustDescGap);
    window.addEventListener('resize', adjustDescGap);
  }

  // ── FAQ accordion ──
  document.querySelectorAll('.faq-question').forEach(btn => {
    btn.addEventListener('click', () => {
      const item = btn.closest('.faq-item');
      const isOpen = item.classList.contains('open');
      document.querySelectorAll('.faq-item.open').forEach(el => {
        el.classList.remove('open');
        el.querySelector('.faq-question').setAttribute('aria-expanded', 'false');
      });
      if (!isOpen) {
        item.classList.add('open');
        btn.setAttribute('aria-expanded', 'true');
      }
    });
  });

  // ── Section background parallax ──
  const parallaxBgs = document.querySelectorAll('.anim-parallax');
  if (parallaxBgs.length && window.innerWidth > 768) {
    const onScroll = () => {
      parallaxBgs.forEach(bg => {
        const wrap = bg.closest('.section-bg-wrap');
        if (!wrap) return;
        const rect = wrap.getBoundingClientRect();
        if (rect.bottom < 0 || rect.top > window.innerHeight) return;
        const progress = (window.innerHeight - rect.top) / (window.innerHeight + rect.height);
        const offset = (progress - 0.5) * 80;
        bg.style.transform = `translateY(${offset}px) scale(1.12)`;
      });
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  // ── Shopify editor: re-reveal content after section updates ──
  if (window.Shopify && window.Shopify.designMode) {
    const makeVisible = (root) => {
      root.querySelectorAll('.reveal, .reveal-left, .reveal-right').forEach(el => {
        el.classList.add('visible');
      });
    };
    makeVisible(document);
    document.addEventListener('shopify:section:load', (e) => makeVisible(e.target));
    document.addEventListener('shopify:section:reorder', () => makeVisible(document));
  }

  // ── Smooth anchor scroll with navbar offset ──
  document.querySelectorAll('a[href^="#"]').forEach(a => {
    a.addEventListener('click', (e) => {
      const target = document.querySelector(a.getAttribute('href'));
      if (!target) return;
      e.preventDefault();
      const barH = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--announce-h') || '0', 10);
      const top = target.getBoundingClientRect().top + window.scrollY - 80 - barH;
      window.scrollTo({ top, behavior: 'smooth' });
    });
  });

});
